__turbopack_context__.v({
  "ButtonActive": "center-btn-module__ib-RBa__ButtonActive",
});
